<ws-modal-wrapper (cancel)="closeModal()"
                  cancelLabel="Close"
                  [hideSave]="true"
                  [loading]="loading"
                  headerLabel="Change History">
    <!-- No filter for now; it was originally included, but we determined it isn't really required (yet at least) -->
    <!--    <div style="display:none;">-->
    <!--        <label class="mr-1 position-relative" style="top:-8px;">Filter: </label>-->
    <!--        <div class="input-group d-inline-block mt-3" style="width: 138px;">-->
    <!--            <weissman-datetime (change)="getHistory()"-->
    <!--                               [(inputDate)]="startDateTime"-->
    <!--                               [dateOnly]="true"-->
    <!--                               [timeZone]="'Central'">-->
    <!--            </weissman-datetime>-->
    <!--        </div>-->
    <!--        <span class="mx-2 position-relative" style="top: -8px;">to</span>-->
    <!--        <div class="input-group d-inline-block mt-3" style="width: 138px;">-->
    <!--            <weissman-datetime (change)="getHistory()"-->
    <!--                               [(inputDate)]="endDateTime"-->
    <!--                               [dateOnly]="true"-->
    <!--                               [rangeEnd]="true"-->
    <!--                               [timeZone]="'Central'">-->
    <!--            </weissman-datetime>-->
    <!--        </div>-->
    <!--    </div>-->
    <div>
        <div style="max-height:600px;overflow-y:auto;">
            <table class="ace-table table-condensed table-striped w-100">
                <thead>
                    <tr>
                        <th>Date/Time *</th>
                        <th>User</th>
                        <th>Field Name</th>
                        <th class="text-end">Old Value</th>
                        <th></th>
                        <th>New Value</th>
                    </tr>
                </thead>
                <tbody>
                    @for (operation of operations; track operation) {
                        @if (operation.operation == OperationType.Insert) {
                            <tr>
                                <td [attr.title]="isCalendarDisplay(operation.operationDate) ? displayDate(operation.operationDate) : undefined">
                                    {{ calendarDisplayDate(operation.operationDate) }}
                                </td>
                                <td>
                                    @if (operation.userId !== NullUserId) {
                                        <span> {{ operation.userFirstName }} {{ operation.userLastName }}</span>
                                    }
                                    @if (operation.userId === NullUserId) {
                                        <span><em>System Update</em></span>
                                    }
                                </td>
                                <td colspan="4">{{ originalTitle }} Created</td>
                            </tr>
                        }
                        @if (operation.operation == OperationType.Snapshot) {
                            <tr>
                                <td colspan="6" class="text-center">(history not available
                                    before {{ displayDate(operation.operationDate) }})
                                </td>
                            </tr>
                        }
                        @for (change of operation.changes; track change; let cIdx = $index) {
                            <tr>
                                @if (cIdx == 0) {
                                    <td [attr.rowspan]="operation.changes.length"
                                        [attr.title]="isCalendarDisplay(operation.operationDate) ? displayDate(operation.operationDate) : undefined"
                                        style="white-space: nowrap;">
                                        {{ calendarDisplayDate(operation.operationDate) }}
                                    </td>
                                }
                                @if (cIdx == 0) {
                                    <td [attr.rowspan]="operation.changes.length" style="white-space: nowrap;">
                                        @if (operation.userId !== NullUserId) {
                                            <span> {{ operation.userFirstName }} {{ operation.userLastName }}</span>
                                        }
                                        @if (operation.userId === NullUserId) {
                                            <span><em>System Update</em></span>
                                        }
                                    </td>
                                }
                                <td [hidden]="cIdx > 2 && !operation.expanded" style="white-space: nowrap;">
                                    @if (change.historyFieldType == HistoryFieldType.ClientServiceResponsibility && change.properties.fromDate) {
                                        <span
                                            [title]="'from ' + change.properties.fromDate.toLocaleDateString()">
                                            {{ change.fieldName }}
                                        </span>
                                    }
                                    @if (change.historyFieldType != HistoryFieldType.ClientServiceResponsibility || !change.properties.fromDate) {
                                        <span
                                        >
                                            {{ change.fieldName }}
                                        </span>
                                    }
                                </td>
                                <td class="text-end"
                                    [hidden]="cIdx > 2 && !operation.expanded"
                                    style="word-break: break-word;">
                                    @if ((change.oldValue === null || change.oldValue === '') && change.newValue !== null) {
                                        <em>blank</em>
                                    }
                                    @if (change.oldValue !== null && change.oldValue !== '') {
                                        <span>
                                            @if (change.historyFieldType == HistoryFieldType.DateTime) {
                                                <weissman-datetime [(inputDate)]="change.oldValue"
                                                                   [readOnly]="true">
                                                </weissman-datetime>
                                            }
                                            @if (change.historyFieldType == HistoryFieldType.Date) {
                                                <weissman-datetime [(inputDate)]="change.oldValue"
                                                                   [readOnly]="true"
                                                                   [dateOnly]="true">
                                                </weissman-datetime>
                                            }
                                            @if (change.historyFieldType != HistoryFieldType.DateTime && change.historyFieldType != HistoryFieldType.Date && change.historyFieldType != HistoryFieldType.TaxAuthority) {
                                                <span>
                                                    {{ getDisplayValue(change.oldValue, change.historyFieldType) }}
                                                </span>
                                            }
                                            @if (change.historyFieldType == HistoryFieldType.ClientServiceResponsibility && change.oldValueProperties.relatedEntityType) {
                                                <span
                                                    [title]="change.oldValueProperties.relatedEntityName">
                                                    (from {{ resolveCSRRelationship(change.oldValueProperties) }})
                                                </span>
                                            }
                                            @if (change.historyFieldType == HistoryFieldType.TaxAuthority) {
                                                <span>
                                                    @if (!change.expanded) {
                                                        <span>
                                                            <span>{{ getDisplayValue(change.oldValue, change.historyFieldType) }}</span>
                                                            <span class="anchor-style"
                                                                  (click)="change.expanded=true">(details...)</span>
                                                        </span>
                                                    }
                                                    @if (change.expanded) {
                                                        <span>
                                                            <div style="white-space:pre">{{ getExpandedDisplayValue(change.oldValue, change.historyFieldType) }}</div>
                                                            <span class="anchor-style"
                                                                  (click)="change.expanded=false">(hide...)</span>
                                                        </span>
                                                    }
                                                </span>
                                            }
                                        </span>
                                    }
                                </td>
                                <td [hidden]="cIdx > 2 && !operation.expanded"
                                    style="text-align: center; padding: 0 10px; vertical-align: middle;">@if (change.oldValue !== null || change.newValue !== null) {
                                    <i class="fa fa-arrow-right"></i>
                                }</td>
                                <td [hidden]="cIdx > 2 && !operation.expanded" style="word-break: break-word;">
                                    @if ((change.newValue === null || change.newValue === '') && change.oldValue !== null) {
                                        <em>blank</em>
                                    }
                                    @if (change.newValue !== null && change.newValue !== '') {
                                        <span>
                                            @if (change.historyFieldType == HistoryFieldType.DateTime) {
                                                <weissman-datetime [(inputDate)]="change.newValue"
                                                                   [readOnly]="true">
                                                </weissman-datetime>
                                            }
                                            @if (change.historyFieldType == HistoryFieldType.Date) {
                                                <weissman-datetime [(inputDate)]="change.newValue"
                                                                   [readOnly]="true"
                                                                   [dateOnly]="true">
                                                </weissman-datetime>
                                            }
                                            @if (change.historyFieldType != HistoryFieldType.DateTime && change.historyFieldType != HistoryFieldType.Date && change.historyFieldType != HistoryFieldType.TaxAuthority) {
                                                <span>
                                                    {{ getDisplayValue(change.newValue, change.historyFieldType) }}
                                                </span>
                                            }
                                            @if (change.historyFieldType == HistoryFieldType.ClientServiceResponsibility && change.newValueProperties.relatedEntityType) {
                                                <span
                                                    [title]="change.newValueProperties.relatedEntityName">
                                                    (from {{ resolveCSRRelationship(change.newValueProperties) }})
                                                </span>
                                            }
                                            @if (change.historyFieldType == HistoryFieldType.TaxAuthority) {
                                                <span>
                                                    @if (!change.expanded) {
                                                        <span>
                                                            <span>{{ getDisplayValue(change.newValue, change.historyFieldType) }}</span>
                                                            <span class="anchor-style"
                                                                  (click)="change.expanded=true">(details...)</span>
                                                        </span>
                                                    }
                                                    @if (change.expanded) {
                                                        <span>
                                                            <div style="white-space:pre">{{ getExpandedDisplayValue(change.newValue, change.historyFieldType) }}</div>
                                                            <span class="anchor-style"
                                                                  (click)="change.expanded=false">(hide...)</span>
                                                        </span>
                                                    }
                                                </span>
                                            }
                                        </span>
                                    }
                                </td>
                            </tr>
                        }
                        @if (operation.changes.length > 3 && !operation.expanded) {
                            <tr>
                                <td class="change-history-more-row" colspan="6" (click)="operation.expanded = true">
                                    <i class="fa fa-ellipsis-h fa-lg"></i>
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </div>
        <hr class="my-1"/>
        <div class="text-muted ms-4">* All times CST</div>
    </div>
</ws-modal-wrapper>
